import React from "react";
import styles from "../../pages/styles";

const SkillCard = ({ title }) => {
  return (
    <div className="bg-orangeprimary/90 hover:bg-orangeprimary rounded-full py-3 px-6 text-center shadow-sm hover:shadow-md transition-all border-2 border-orangeprimary">
      <p className={`${styles.paragraph} text-md mb-0 font-medium`}>{title}</p>
    </div>
  );
};

const SkillsClasses = ({ title, desc }) => {
  return (
    <div className="w-full bg-darkprimary py-8 md:py-10 px-4 md:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto px-2 md:px-4 mb-6 md:mb-8">
          <h2 className={`${styles.biggerheadingwhite} mb-3 md:mb-4`}>
            {title}
          </h2>
          <p className={`${styles.paragraphwhite}`}>{desc}</p>
        </div>
        <div className="flex flex-wrap gap-4 justify-center max-w-5xl mx-auto">
          <SkillCard title="Strategic Thinking" />
          <SkillCard title="Interactive Learning" />
          <SkillCard title="Collaborative Environment" />
          <SkillCard title="Personalized Attention" />
          <SkillCard title="Problem-Solving Skills" />
          <SkillCard title="Innovation Encouraged" />
          <SkillCard title="Project-Based Learning" />
          <SkillCard title="Digital Literacy" />
        </div>
      </div>
    </div>
  );
};

export default SkillsClasses;
